import React from "react";
import { connect } from "react-redux";
import { Modal, Form } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicImport from "../../components/frame/DynamicImport";
import DynamicButton from "../../components/frame/DynamicButton";
import DynamicFilter from "../../components/frame/DynamicFilter";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import {
	fetchEmployeesList
} from '../../actions/employee-management-actions';
import {
	fetchDepartmentsList
} from '../../actions/department-structure-actions';
import {
	changeAirticketAllowance,
	selectAirticketAllowance,
	updateAirticketAllowance,
} from "../../actions/salary-allowance-actions";
import airticketAllowanceService 
from "../../services/SalaryAllowance/airticket-allowance-service";


class AirticketAllowance extends ReduxAbstract {

	initReload = true
	moduleName = "salaryAllowance"
	childModuleName = "airticketAllowance"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		importModalStatus: false
	}

	actions = {
		changeAction: this.props.changeAirticketAllowance,
		selectAction: this.props.selectAirticketAllowance,
		updateAction: this.props.updateAirticketAllowance,

		deleteAction: airticketAllowanceService.deleteAirticketAllowance,
		createAction: airticketAllowanceService.createAirticketAllowance,
		exportAction: airticketAllowanceService.exportAirticketAllowance,
	}

	headerColumn = [{
			title: "新增",
			access: "c_value",
			icon: "plus-circle-o",
			click: () => this.createData()
		}, {
			title: "批量删除",
			access: "d_value",
			icon: "delete",
			click: this.publicDelete
		}, {
			title: "导入",
			access: "import_value",
			icon: "cloud-upload-o",
			click: this.toggleImportModal
		}, {
			title: "导出",
			access: "export_value",
			icon: "cloud-download-o",
			click: this.publicExport
		}
	]

	filterColumn = [{
			type: "person"
		}, {
			type: "department"
	}]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-small'
		},{
			title: '中文名',
			dataIndex: 'real_name',
			key: 'real_name',
			className: 'table-global-head-small'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head-large'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '补贴年份',
			dataIndex: 'subsidy_year',
			key: 'subsidy_year',
			className: 'table-global-head-short'
		}, {
			title: '补贴总金额',
			dataIndex: 'subsidy_total_amount',
			key: 'subsidy_total_amount',
			className: 'table-global-head-6x'
		}, {
			title: '补贴金额',
			dataIndex: 'subsidy_amount',
			key: 'subsidy_amount',
			className: 'table-global-head-short'
		}, {
			title: '剩余补贴金额',
			dataIndex: 'subsidy_surplus_amount',
			key: 'subsidy_surplus_amount',
			className: 'table-global-head',
			render: (text, record) => record.subsidy_total_amount - record.subsidy_amount
		}, {
			title: '发放月份',
			dataIndex: 'release_month',
			key: 'release_month',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-short',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "编辑",
			access: "u_value",
			click: this.updateData.bind(this, record, index)
		}
	]

	formColumn = () => [{
			label: "员工姓名",
			key: "employee_id",
			valueKey: "real_name",
			type: "person",
			span: 24,
			rules: {
				disabled: null !== this.state.currentIndex
			}
		}, {
			label: "补贴年份",
			key: "subsidy_year",
			type: "number",
			span: 24,
			rules: {min: 1900, max: 2900, step: 1}
		}, {
			label: "补贴总金额",
			key: "subsidy_total_amount",
			type: "number",
			span: 24,
			rules: {min: 0, step: 0.01}
		}, {
			label: "剩余补贴金额",
			key: "subsidy_surplus_amount",
			type: "text",
			span: 24,
			hide: null === this.state.currentIndex
		}, {
			label: "补贴金额",
			key: "subsidy_amount",
			type: "number",
			span: 24,
			rules: {min: 0, step: 0.01}
		}, {
			label: "发放月份",
			key: "release_month",
			type: "month",
			span: 24,
		}
	]

	customComponentWillMount () {
		this.props.fetchDepartmentsList();
	}

	createData = () => this.setState({
		currentData: {},
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null
	})

	updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index
	})

	publicSubmit = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			const submitData = {
				...this.state.currentData,
				...values,
				release_month: values.release_month.format("YYYY-MM"),
				subsidy_surplus_amount: values.subsidy_total_amount - values.subsidy_amount
			}
			const callee = null === this.state.currentIndex ?
				this.publicCreate : this.publicUpdate;
			callee(submitData);
		}
	})

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.dataSource().filters}
						setFilter={this.publicChange} />
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="机票补贴"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						selectEmployee={this.props.fetchEmployeesList}
						employees={this.props.employeeManagement.employeeList}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<div>
					<DynamicImport visible={this.state.importModalStatus}
						toggleModal={this.toggleImportModal}
						downloadTemplate={airticketAllowanceService.downloadAirticketAllowanceTemplate}
						importFile={airticketAllowanceService.importAirticketAllowance} />
				</div>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure,
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	fetchDepartmentsList,
	changeAirticketAllowance,
	selectAirticketAllowance,
	updateAirticketAllowance,
}

AirticketAllowance = Form.create()(AirticketAllowance);

AirticketAllowance = connect(mapStateToProps, mapDispatchToProps)(AirticketAllowance);

export default LayoutWrapper(AirticketAllowance);





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/AirticketAllowance.js